const normalizeCity = (city: string) => {
  return city.toLowerCase().replace(/^(г\.|город|гор\.)?\s*/, "");
};


/**
 * Проверяет, принадлежит ли адрес к зоне доставки
 * @param cityOrAddress - Город или адрес
 * @param shippingZoneName - Название зоны доставки
 * @returns true, если адрес принадлежит зоне доставки, false в противном случае
 */
export const checkShippingZone = (cityOrAddress: string, shippingZoneName: string) => {
  const normalizedAddress = normalizeCity(cityOrAddress);
  const normalizedShippingZone = normalizeCity(shippingZoneName);

  return normalizedAddress.includes(normalizedShippingZone);
};
